import React, { Fragment, useState } from 'react'
import { Form, Input, Button, Col, Typography, Radio, message } from 'antd'
import './index.less'
import { Header } from '/components/Header/'
import api from 'services/api'
import { FormConfirmation } from '../../components/FormConfirmation'

const radioStyle = {
  display: 'block',
  height: '30px',
  lineHeight: '30px',
}

const layout = {
  labelCol: { xs: { span: 24 }, lg: { span: 7 } },
  wrapperCol: { xs: { span: 24 }, lg: { span: 8 } },
}

const serverErrorMessage =
  'Ocorreu um erro interno. Por favor, tente novamente em alguns minutos'

const questionOneLabel = (
  <Typography.Title level={4}>
    <span style={{ color: '#d60202' }}>*</span>1. Informe o número do seu
    pedido/compra.
  </Typography.Title>
)

const nameLabel = (
  <Typography.Text style={{ fontSize: '18px' }}>
    Nome completo do titular do cartão de crédito:
  </Typography.Text>
)
const cpfLabel = (
  <Typography.Text style={{ fontSize: '18px' }}>CPF:</Typography.Text>
)

const bornAtLabel = (
  <Typography.Text style={{ fontSize: '18px' }}>
    Data de nascimento:
  </Typography.Text>
)

const telLabel = (
  <Typography.Text style={{ fontSize: '18px' }}>
    Telefone com DDD do TITULAR DO CARTÃO:
  </Typography.Text>
)

const questionThreeLabel = (
  <Typography.Title level={4}>
    3. Qual o horário devemos fazer a ligação?
  </Typography.Title>
)

export const Confirmation = () => {
  const [answers, setAnswers] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [step, setStep] = useState(1)

  const handleChange = property => {
    return function(e) {
      if (e.preventDefault) e.preventDefault()
      const param = { [property]: e.target.value }
      setAnswers({ ...answers, ...param })
    }
  }

  const handleSubmit = async e => {
    e.preventDefault()
    setIsLoading(true)
    try {
      const { data } = await api.post('/send-validation-form-data', answers)

      if (data.code == 'Internal server error')
        message.error(serverErrorMessage)
      else {
        message.success('Dados enviados!')
        setStep(2)
      }
    } catch (error) {
      message.error(serverErrorMessage)
    }

    setIsLoading(false)
  }

  return (
    <Fragment>
      <div id='container'>
        <div className='wrapper'>
          <div id='main' style={{ marginRight: '0px' }} className='tab'>
            <Header />

            <Col xs={{ span: 22, offset: 1 }} lg={{ span: 12, offset: 6 }}>
              <div className='form-wrapper'>
                {step == 1 ? (
                  <Form layout='vertical' onSubmit={handleSubmit}>
                    <Typography.Title
                      level={2}
                      style={{ marginBottom: '36px', textAlign: 'center' }}
                    >
                      GCM Games - Validação de compra
                    </Typography.Title>
                    <Form.Item
                      name='orderId'
                      label={questionOneLabel}
                      {...layout}
                    >
                      <Input
                        type='text'
                        name='orderId'
                        value={answers?.orderId}
                        onChange={handleChange('orderId')}
                        required
                      />
                    </Form.Item>
                    <Typography.Title level={4}>
                      <span style={{ color: '#d60202' }}>*</span> 2. Precisamos
                      confirmar alguns dados para realizar a validação e liberar
                      o seu pedido. Tenha atenção ao enviar os dados, caso envie
                      errado poderá atrasar o seu pedido.
                      <br />
                      <br /> <span style={{ color: '#d60202' }}>*</span> Caso
                      tenha sido via saldo, envie os dados do titular do
                      cadastro no Mercado Livre.
                    </Typography.Title>
                    <Form.Item name='name' label={nameLabel} {...layout}>
                      <Input
                        type='text'
                        name='name'
                        value={answers?.name}
                        onChange={handleChange('name')}
                        required
                      />
                    </Form.Item>
                    <Form.Item name='cpf' label={cpfLabel} {...layout}>
                      <Input
                        type='text'
                        name='cpf'
                        value={answers?.cpf}
                        onChange={handleChange('cpf')}
                        required
                      />
                    </Form.Item>
                    <Form.Item name='bornAt' label={bornAtLabel} {...layout}>
                      <Input
                        type='text'
                        name='bornAt'
                        value={answers?.bornAt}
                        onChange={handleChange('bornAt')}
                        required
                      />
                    </Form.Item>
                    <Form.Item name='tel' label={telLabel} {...layout}>
                      <Input
                        type='text'
                        name='tel'
                        value={answers?.tel}
                        onChange={handleChange('tel')}
                        required
                      />
                    </Form.Item>

                    <Form.Item label={questionThreeLabel}>
                      <Radio.Group onChange={handleChange('callTime')}>
                        <Radio style={radioStyle} value={'Manhã'}>
                          <Typography.Text style={{ fontSize: '18px' }}>
                            Pela manhã
                          </Typography.Text>
                        </Radio>
                        <Radio style={radioStyle} value={'Tarde'}>
                          <Typography.Text style={{ fontSize: '18px' }}>
                            Pela tarde
                          </Typography.Text>
                        </Radio>
                        <Radio style={radioStyle} value={'Noite'}>
                          <Typography.Text style={{ fontSize: '18px' }}>
                            Pela noite
                          </Typography.Text>
                        </Radio>
                        <Radio style={radioStyle} value={'Qualquer'}>
                          <Typography.Text style={{ fontSize: '18px' }}>
                            Qualquer horário
                          </Typography.Text>
                        </Radio>
                      </Radio.Group>
                    </Form.Item>

                    <div style={{ textAlign: 'center' }}>
                      <Button
                        type='primary'
                        htmlType='submit'
                        id='submit'
                        className='btn btn-big'
                        loading={isLoading}
                      >
                        Enviar
                      </Button>
                    </div>
                  </Form>
                ) : (
                  <FormConfirmation />
                )}
              </div>
            </Col>
          </div>
        </div>
      </div>
    </Fragment>
  )
}
